import { useEffect, useState } from "react";
import { format } from "date-fns";
import _, { orderBy } from "lodash";
import { connect } from "react-redux";
import Select from "react-select";

import { Actions as PAYPERIOD_ACTIONS } from "../../store/actions/payPeriodActions";
import { Actions as ACTIONS } from "../../store/actions/payslipActions";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import PayslipTable from "./PayslipTable";

const PayslipHistory = ({ payslips, org, payPeriods, userPermissions, getPayslips, columns }) => {
	const [payPeriod, setPayPeriod] = useState(null);
	const sortedPayPeriods = orderBy(payPeriods, ["year", "periodSort"], ["desc", "desc"]);

	useEffect(() => {
		if (!payPeriod && payPeriods) {
			setPayPeriod(sortedPayPeriods[1] || sortedPayPeriods[0]);
		}
	}, [sortedPayPeriods, org]);

	useEffect(() => {
		if (!payPeriod) return;

		getPayslips({ payPeriodId: payPeriod.value });
	}, [payPeriod, org]);

	if (userPermissions == "None") return <InvalidPermissions />;

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Payslips</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="content">
				<div
					className="col-sm-6"
					style={{ paddingLeft: 0 }}
				>
					<label htmlFor="material-text">Pay Period</label>
					<Select
						value={payPeriod}
						options={sortedPayPeriods}
						onChange={setPayPeriod}
						styles={{
							menu: (provided) => ({
								...provided,
								zIndex: 9999,
							}),
						}}
					/>
					<div className="clearfix" />
				</div>
			</div>
			<div className="clearfix" />

			<PayslipTable
				payslips={payslips}
				columns={columns}
				location="payrollHistory"
			/>

			<div className="col-xs-12 mb-32" />
			<div className="clearfix" />
		</>
	);
};

const mapStateToProps = (state) => {
	const payPeriods = state?.payPeriods?.periods?.map((period) => {
		const paySchedule = state.company.settings?.paySchedules?.find((s) => s.id == period?.paySchedule);
		return {
			label: `${paySchedule?.name ? paySchedule?.name : "Pay"}  ${period?.period} -${
				period?.periodStart && period?.periodEnd
					? ` (${format(new Date(period.periodStart), "do MMM")} to ${format(
							new Date(period.periodEnd),
							"do MMM",
						)}),`
					: ""
			} ${period?.year}`,
			value: period.id,
			period: Number(period.period),
			year: Number(period?.year),
			periodSort: Number(period?.period) / 12 / (Number(period?.payPeriods ?? 52) / 12),
		};
	});
	const userPermissions = state?.permissions?.my?.permissions?.payroll;

	const jurisdiction = state.company?.settings?.jurisdiction;

	const taxList = {
		UK: { PAYE: "PAYE", NIC: "NIC", StudentLoan: "Student Loans", Pension: "Pensions" },
		MT: { FSS: "Income Tax", SSC: "Social Security" },
	};

	const columns = [
		{ hidden: true },
		{ title: "Name", code: "employee", sort: true },
		{ title: "Gross Pay", code: "gross", sort: true },
		...Object.values({ ...taxList[jurisdiction] }).map((tax) => ({
			title: tax,
			info: "Click on values to view Tax Calculations",
		})),
		{ title: "Net Amount", code: "net", sort: true },
		{ title: "Portal Access" },
		{ hidden: true },
	];

	return {
		loading: state.payslipHistory?.updating,
		payslips: state.payslipHistory?.payslips || [],
		payPeriods,
		userPermissions,
		org: state.company?.settings?.org,
		columns,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getPayslips: (params) => dispatch(ACTIONS.getPayslips(params)),
	getPayPeriods: () => dispatch(PAYPERIOD_ACTIONS.getPayPeriods()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayslipHistory);
